/* eslint-disable react-hooks/exhaustive-deps */
// Core
import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import {
    CloudUploadOutlined,
    UserOutlined,
    PlusCircleOutlined,
    CloseCircleOutlined,
} from "@ant-design/icons";
import { NavLink, useNavigate } from "react-router-dom";

// Styles
import { colors } from "assets/styles/colors";
import { CommonGlassContainer, Grid, H1Head, Label } from "assets/styles/globalStyles";

// Types
import { FontSizes, FontWeight } from "utils/enums";
import {
    AboutWrapper, OtherEvApps
} from "./styles";

// Components
import Button from "components/Button";
import InputField from "components/InputField";
import Select from "components/Select";
import Loader from "components/Loader";

// Others
import { fetchData } from "utils/fetch";
import { restAPIs } from "utils/restAPIs";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { APP_ID } from "config/constants";
// Components

import Playstore from 'assets/images/play-store-round.png'
import Appstore from 'assets/images/app_store_round.png'
import Footer from "components/Footer";

// Types


const About: React.FC = () => {
    const { currentLang } = useSelector((store: any) => store.commonData);
    const navigate = useNavigate();
    const [isLoading, setLoading] = useState(false);
    const [aboutData, setAboutData] = useState<any>({});
    const [electronicData, setElectronicData] = useState<any>({});
    const [founderData, setFounderData] = useState<any>({});
    const [evApps, setEVApps] = useState([])
    const { t } = useTranslation();
    const [pageLoading, setPageLoading] = useState(false);


    const fetchAboutData = async () => {
        setLoading(true)
        const res = await fetchData(restAPIs.getEVApps(currentLang?.id, APP_ID));
        setAboutData(res.applications[0]);
        setLoading(false)
    };

    const fetchElectronicVillage = async () => {
        setLoading(true)
        const res = await fetchData(restAPIs.getEVApps(currentLang?.id, 31));
        setElectronicData(res.applications[0]);
        setLoading(false)
    };

    const fetchFounder = async () => {
        setLoading(true)
        const res = await fetchData(restAPIs.getFounderInfo(currentLang?.id));
        setFounderData(res.founder[0]);
        setLoading(false)
    };

    const fetchEVApps = async () => {
        setLoading(true)
        const res = await fetchData(restAPIs.getEVApps(currentLang?.id));
        setEVApps(res.applications);
        setLoading(false)
    }


    useEffect(() => {
        window.scrollTo(0, 0);
        fetchAboutData();
        fetchElectronicVillage();
        fetchFounder();
        fetchEVApps();
    }, [currentLang]);

    const handleApp = (id: any) => {
        navigate('/about/app/' + id)
    }


    if (pageLoading) return <Loader />;

    return (
        <>


            <AboutWrapper>

                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-md-11">
                            <H1Head style={{ color: '#fff', marginBottom: '20px' }}>About Us</H1Head>
                            <CommonGlassContainer className="___comn_txt">
                                <div className='row'>
                                    <div className='col-md-9'>
                                        <h4 >{aboutData?.tagline}</h4>
                                        <h1 className='__common-head' style={{ fontSize: '2rem' }}>{aboutData?.name}</h1>
                                        <p dangerouslySetInnerHTML={{ __html: aboutData?.description }} style={{ lineHeight: '2', marginTop: '16px' }}></p>
                                    </div>
                                    <div className='col-md-3'>
                                        <img src={aboutData?.applicationIcon} alt="" width={'100%'} height={'200px'} style={{ objectFit: 'cover', minHeight: '200px', marginTop: '10px', textAlign: 'justify' }} />
                                    </div>
                                </div>
                            </CommonGlassContainer>

                            <CommonGlassContainer className="___comn_txt">
                                <div className='row'>

                                    <div className='col-md-3 '>
                                        <img src={electronicData?.applicationIcon} alt="" width={'100%'} height={'200px'} style={{ objectFit: 'cover', minHeight: '290px', marginBottom: '10px' }} />
                                    </div>
                                    <div className='col-md-9 '>
                                        <h4 >{electronicData?.tagline}</h4>
                                        <h1 className='__common-head' style={{ fontSize: '2rem' }}>{electronicData?.name}</h1>
                                        <p dangerouslySetInnerHTML={{ __html: electronicData?.description }} style={{ lineHeight: '2', fontSize: '17px', marginTop: '16px', textAlign: 'justify' }}></p>
                                    </div>
                                </div>
                            </CommonGlassContainer>

                            <CommonGlassContainer className="___comn_txt">
                                <div className='row'>

                                    <div className='col-md-9 __founder'>
                                        <h4 >{t('founder')}</h4>
                                        <h1 className='__common-head' style={{ fontSize: '2rem' }}>{founderData?.name}</h1>
                                        <p style={{ lineHeight: '2', fontSize: '17px', marginTop: '16px', textAlign: 'justify' }} className="__inr_p" dangerouslySetInnerHTML={{ __html: founderData?.description }}></p>
                                        <Button
                                            label={t('more')}
                                            width="120px"
                                            marginTop={15}
                                            onClickHandler={()=>navigate('/founder')}
                                        />
                                    </div>
                                    <div className='col-md-3 '>
                                        <img src={founderData?.logo} alt="" width={'100%'} height={'200px'} style={{ objectFit: 'cover', minHeight: '290px', marginTop: '10px' }} />
                                    </div>
                                </div>
                            </CommonGlassContainer>
                            <h3 style={{ color: "#fff", textAlign: 'center', marginTop: '40px', marginBottom: '30px' }}>{t('other_ev_apps')}</h3>
                            <OtherEvApps>

                                {evApps && evApps.map((item: any, idx) => {
                                    return (
                                        <CommonGlassContainer className="__single_app" key={idx} onClick={() => handleApp(item.appId)}>
                                            <img src={item?.applicationIcon} />
                                            <h6>{item?.name}</h6>
                                        </CommonGlassContainer>
                                    )
                                })}
                            </OtherEvApps>

                        </div>
                    </div>
                </div>

                <Footer />

            </AboutWrapper>
        </>
    );
};

export default About;

